const defaultState = {
  requesting: false,
  error: false,
  result: null
}

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'SIGNUP_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null
      }
    case 'SIGNUP_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload
      }
    case 'SIGNUP_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload
      }
    default:
      return state
  }
}
